import PropTypes from "prop-types";
import me from "models/me";

export default function (defaultSort, defaultOrder, preferenceKey) {
    return function (Component) {
        class SortComponent extends Component {
            constructor(props) {
                super(props);

                this.defaultSort = defaultSort;
                this.defaultSortOrder = defaultOrder;

                this.state = this.state || {};

                let sort = props.location.query.__sort || "";
                let sortOrder = props.location.query.__sort_order || "";

                // if there is no sort params in url, lets search some in viewPreferences
                if ((!sort || !sortOrder) && preferenceKey) {
                    const sortBrandPreference = props.scope.brand.hasPreference(preferenceKey);
                    const sortUserPreference = me.getViewPref(preferenceKey);

                    if (sortUserPreference) {
                        [sort = "", sortOrder = ""] = (sortUserPreference || "").split(".");
                    } else if (sortBrandPreference) {
                        const translatedValues = translateValues(sortBrandPreference);
                        sort = translatedValues.sort;
                        sortOrder = translatedValues.sortOrder;
                    }
                }

                this.state.sort = sort || defaultSort;
                this.state.sortOrder = sortOrder || defaultOrder;
            }

            getChildContext() {
                const childContext = super.getChildContext ? super.getChildContext() : {};
                childContext.sort = this.state.sort;
                childContext.sortOrder = this.state.sortOrder;
                return childContext;
            }

            shouldComponentUpdate(nextProps, nextState, nextContext) {
                if (nextState.sort !== this.state.sort || nextState.sortOrder !== this.state.sortOrder) {
                    return true;
                }

                if (super.shouldComponentUpdate) {
                    return super.shouldComponentUpdate(nextProps, nextState, nextContext);
                } else {
                    return true;
                }
            }
        }

        SortComponent.childContextTypes = {
            sort: PropTypes.string.isRequired,
            sortOrder: PropTypes.oneOf(["asc", "desc"]).isRequired,
            ...SortComponent.childContextTypes,
        };

        SortComponent._pageComponents = SortComponent._pageComponents || [];
        SortComponent._pageComponents.push("sort");

        SortComponent.displayName = Component.displayName || Component.name || "Component";

        return SortComponent;
    };
}

function translateValues(gallerySort) {
    let sort = "";
    let sortOrder = "";

    switch (gallerySort) {
        case "merchandised":
            sort = "__merchandising_order";
            sortOrder = "asc";
            break;
        case "created_on":
            sort = "__created_on";
            sortOrder = "desc";
            break;
        case "name_asc":
            sort = "name";
            sortOrder = "asc";
            break;
        case "name_desc":
            sort = "name";
            sortOrder = "desc";
            break;
        case "style_asc":
            sort = "style_number";
            sortOrder = "asc";
            break;
        case "style_desc":
            sort = "style_number";
            sortOrder = "desc";
            break;
        default:
            sort = "__created_on";
            sortOrder = "desc";
    }

    return { sort, sortOrder };
}
